import React from "react";
import Content from "components/Content";
import Label from "components/Label";
import Image from "next/image";
import Link from "next/link";

import Mandala from "../../../../../public/404-mandala.png";

import styles from "./styles.module.scss";

const NotFound = () => (
  <div className={styles.container}>
    <Content
      containerClassName={styles.contentWrapper}
      contentClassName={styles.content}
    >
      <Label className={styles.title} color="primary" variant="h2-centered">
        Oops, this page doesn&apos;t exist!
      </Label>
      <Link href="/blog">
        <Label
          className={styles.link}
          color="primary"
          variant="s2-centered"
          useMarkdown
          linkColor="accent"
        >
          Back to Blog Home
        </Label>
      </Link>
      <div className={styles.image}>
        <Image layout="fill" objectFit="contain" alt="" src={Mandala} />
      </div>
    </Content>
  </div>
);

export default NotFound;
